<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import {mapMutations} from 'vuex'
import weixinModule from "@/common/weixinModel.js"
export default {
	onLaunch: function() {
		let userInfo = uni.getStorageSync('userInfo')
		 // 在页面加载时读取sessionStorage
		  if (userInfo) {
			  this.SET_MEMBER(JSON.parse(userInfo))
		  }
		this.getSetting()
	  
		console.log('App Launch');
	},
	onShow: function() {
		console.log('App Show');
	},
	onHide: function() {
		console.log('App Hide');
	},
	methods: {
		...mapMutations(['SET_MEMBER']),
		getSetting(){
			let self = this
			function serializeWithPrimaryKey(a, key){
			    var o = {};
				a.forEach(item=>{
					 let lineKey = item[key].replace(/\./g, '_');
					 let subKey = self.$gUtil.toHump(lineKey)
					 o[subKey] = item;
				})
			    return o;
			}
			let userId = ''
			let member = this.$store.state.member
			if(member && member.userId){
				userId = member.userId
			}
			this.member = this.$store.state.member
			this.$r.get("/rest/setting/basicSetting",{settingAlias:'app.share.pic,app.share.desc,app.share.title,app.pay.successful'}).then((res) => {
				if (res.success) {
					this.setting = serializeWithPrimaryKey(res.result.records, 'settingAlias');
					console.log(this.setting)
					this.appPaySuccessful = this.setting.appPaySuccessful.settingValue
					uni.setStorage({
						key: 'configComn',
						data: {share_title:this.setting.appShareTitle.settingValue
						,share_desc:this.setting.appShareDesc.settingValue
						,share_pic:this.setting.appSharePic.settingValue,
						share_url:location.origin+'?inviterUser='+userId}
					});
				    weixinModule.WXConfig(this)
				}
			})
		},
	}
};
</script>

<style lang="scss">
/*每个页面公共css */
@import '~@/static/style/app.scss';
</style>